import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './HomeOwnerSupport.module.css';

const HomeOwnerSupport = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Here you would normally send the data to your backend
    
    // Reset form and show success message
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
    setSubmitted(true);
    
    // Hide success message after 5 seconds
    setTimeout(() => {
      setSubmitted(false);
    }, 5000);
  };

  return (
    <div className={styles.supportContainer}>
      <div className={styles.heroSection}>
        <div className={styles.heroContent}>
          <h1>How Can We Help?</h1>
          <p>We're here to support you through your home improvement journey</p>
        </div>
      </div>

      <div className={styles.supportSection}>
        <div className={styles.supportGrid}>
          <div className={styles.supportCard}>
            <div className={styles.iconContainer}>
              <i className="fas fa-envelope"></i>
            </div>
            <h3>Email Support</h3>
            <p>Send us a message and we'll get back to you within 24 hours</p>
            <a href="mailto:support@smarttechproserve.com" className={styles.linkButton}>
              Email Us
            </a>
          </div>

          <div className={styles.supportCard}>
            <div className={styles.iconContainer}>
              <i className="fas fa-book"></i>
            </div>
            <h3>Knowledge Base</h3>
            <p>Find answers to commonly asked questions</p>
            <Link to="/homeowner/knowledge-base" className={styles.linkButton}>
              Browse Articles
            </Link>
          </div>

          <div className={styles.supportCard}>
            <div className={styles.iconContainer}>
              <i className="fas fa-video"></i>
            </div>
            <h3>Video Tutorials</h3>
            <p>Watch step-by-step guides on how to use our tools</p>
            <Link to="/homeowner/tutorials" className={styles.linkButton}>
              Watch Videos
            </Link>
          </div>
        </div>
      </div>

      <div className={styles.contactFormSection}>
        <div className={styles.formContainer}>
          <h2>Contact Us</h2>
          <p>Fill out the form below and we'll get back to you as soon as possible</p>
          
          {submitted && (
            <div className={styles.successMessage}>
              <i className="fas fa-check-circle"></i>
              Your message has been sent! We'll get back to you shortly.
            </div>
          )}

          <form onSubmit={handleSubmit} className={styles.contactForm}>
            <div className={styles.formGroup}>
              <label htmlFor="name">Your Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Enter your full name"
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="Enter your email address"
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
                placeholder="What is your inquiry about?"
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                placeholder="Please describe your issue or question in detail"
                rows="6"
              ></textarea>
            </div>

            <button type="submit" className={styles.submitButton}>
              Send Message
            </button>
          </form>
        </div>
      </div>

      <div className={styles.legalSection}>
        <h2>Policies & Disclaimers</h2>
        
        <div className={styles.policyContainer}>

          
          <div className={styles.policyCard}>
            <h3>Privacy Policy</h3>
            <p>We value your privacy and are committed to protecting your personal information. Learn how we collect, use, and safeguard your data.</p>
            <Link to="/homeowner/privacy-policy" className={styles.policyLink}>Read Full Policy</Link>
          </div>
          
          <div className={styles.policyCard}>
            <h3>Terms of Service</h3>
            <p>By using our services, you agree to our terms and conditions. Please review them carefully to understand your rights and responsibilities.</p>
            <Link to="/homeowner/terms-of-service" className={styles.policyLink}>Read Full Terms</Link>
          </div>
        </div>
      </div>

      <div className={styles.faqSection}>
        <h2>Frequently Asked Questions</h2>
        
        <div className={styles.faqContainer}>
          <div className={styles.faqItem}>
            <h3>How do I upload contractor quotes for comparison?</h3>
            <p>Guest users can click "Start Free Comparison Now" on the homepage. Registered users can navigate to Upload & Compare Proposals under Solutions in the navbar, or click "New Comparison" from their dashboard. You can upload PDF, DOC, or image files of your contractor quotes.</p>
          </div>
          
          <div className={styles.faqItem}>
            <h3>How long does the analysis take?</h3>
            <p>AI analysis typically completes within 5-10 minutes of uploading your proposals. The exact time may vary depending on the number and complexity of files uploaded.</p>
          </div>
          
          <div className={styles.faqItem}>
            <h3>Is my information secure?</h3>
            <p>Yes, all your data is encrypted and stored securely. We do not share your personal information with contractors or third parties without your explicit consent.</p>
          </div>
          
          <div className={styles.faqItem}>
            <h3>Can I cancel my subscription?</h3>
            <p>Yes, you can cancel your monthly subscription at any time. Once canceled, you'll retain access until the end of your current billing period, and no future charges will occur. You can resume your subscription anytime during your current period if you change your mind.</p>
          </div>
        </div>
      </div>

      <div className={styles.comingSoonSection}>
        <div className={styles.comingSoonContent}>
          <h2>Coming Soon: AI Assistant</h2>
          <p>We're developing an AI assistant to help answer your questions instantly and guide you through your renovation journey. Stay tuned!</p>
          <div className={styles.comingSoonIcon}>
            <i className="fas fa-robot"></i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeOwnerSupport; 